import "url-search-params-polyfill";

import { useLocation } from "@reach/router";
import { useMemo } from "react";

export default function useSearchParams(...names: string[]) {
  const { search } = useLocation();

  const result = useMemo(() => {
    const params = new URLSearchParams(search);

    const result: (string | null)[] = [];

    for (const name of names) {
      result.push(params.get(name));
    }

    return result;
  }, [...names, search]);

  return result;
}

export function useSearchParamsObject<T extends string[]>(...names: T): { [K in T[number]]: string | null } {
  const { search } = useLocation();

  const resultsObject = useMemo(() => {
    const params = new URLSearchParams(search);
    const resultObject: Record<string, string | null> = {};

    for (const name of names) {
      resultObject[name] = params.get(name);
    }

    return resultObject;
  }, [...names, search]);

  // @ts-expect-error We cannot provide a type guarantee
  return resultsObject;
}
